import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  ResourceAllocationPeriodTimelineBlocks,
  ResourceRequestPeriodTimelineBlocks
} from '~/modules/resourcing/common/chart/components';
import { generateSequence } from '~/modules/resourcing/common/util';

const periodTimelineBlockStyles = makeStyles(theme => ({
  period: {
    borderRight: `1px solid ${theme.palette.grey[500]}`,
    '&:last-child': {
      borderRight: 'none'
    }
  },
  loadingLabel: {
    margin: theme.spacing(0, 0, 0, 0)
  },
  resizeHandleStart: {
    top: theme.spacing(0)
  },
  resizeHandleEnd: {
    top: theme.spacing(0)
  }
}));

export const ResourceAllocationBlockGroup = memo(
  ({
    resourceRequest,
    chartDates,
    chartDisplayDateRange,
    scale,
    isPsaRmpUserSchedulePerfFixEnabled
  }) => {
    const { resourceAllocations = [], ...request } = resourceRequest;
    const [{ start: chartStartDate }] = chartDates;
    const periodTimelineBlockClasses = periodTimelineBlockStyles();

    return (
      <>
        {resourceAllocations.map((resourceAllocation, rowIndex) => (
          <ResourceAllocationPeriodTimelineBlocks
            periodTimelineBlockClasses={
              isPsaRmpUserSchedulePerfFixEnabled
                ? periodTimelineBlockClasses
                : undefined
            }
            isPsaRmpUserSchedulePerfFixEnabled={
              isPsaRmpUserSchedulePerfFixEnabled
            }
            key={resourceAllocation.id}
            rowIndex={rowIndex}
            resourceAllocation={resourceAllocation}
            chartStartDate={chartStartDate}
            scale={scale}
            chartDisplayDateRange={chartDisplayDateRange}
          />
        ))}
        {generateSequence(request.quantity).map(rowItem => (
          <ResourceRequestPeriodTimelineBlocks
            isPsaRmpUserSchedulePerfFixEnabled={
              isPsaRmpUserSchedulePerfFixEnabled
            }
            periodTimelineBlockClasses={
              isPsaRmpUserSchedulePerfFixEnabled
                ? periodTimelineBlockClasses
                : undefined
            }
            key={`${request.id}_${rowItem}`}
            rowIndex={rowItem}
            chartDisplayDateRange={chartDisplayDateRange}
            chartStartDate={chartStartDate}
            resourceRequest={request}
            scale={scale}
            isAllocationBlockPresent={
              resourceAllocations && rowItem < resourceAllocations.length
            }
          />
        ))}
      </>
    );
  }
);

ResourceAllocationBlockGroup.propTypes = {
  scale: PropTypes.string.isRequired,
  chartDates: PropTypes.array.isRequired,
  resourceRequest: PropTypes.object.isRequired,
  chartDisplayDateRange: PropTypes.object.isRequired,
  isPsaRmpUserSchedulePerfFixEnabled: PropTypes.bool
};

export default ResourceAllocationBlockGroup;
